import { createTheme, responsiveFontSizes } from "@mui/material";

let theme = createTheme({
  breakpoints: {
    values: {
      "lg": 1199.98,
      "navbar": 991.98,
      "slider": 767.98
    }

  },
  components: {
    MuiCssBaseline: {
      styleOverrides: `
          h1, h2, h3, h4, h5, h6, p {
            margin: 0;
          },
          ul,li {
            margin: 0;
            padding: 0;
          },
          ol {
            padding-left: 20px;
          }
          
        `
    }
  },
  typography: {
    allVariants: {
      fontFamily: "'Montserrat', san-serif",
      textTransform: 'none',
      fontWeight: 400,
      fontSize: 16,
      lineHeight: "28px",
      color: "#202641",
      letterSpacing: "0.2px",
    },
  },
});

theme = responsiveFontSizes(theme, { factor: 14 / 16, breakpoints: ['xs', 'sm'] });

export default theme